import { Parcel, ParcelFilter } from './../webApi/DataModels'
import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '@/webApi'
class DropCostState {
  public dropCostParcels:Parcel[] = []
}
const mutations = <MutationTree<DropCostState>>{
  setDropCostParcels (state:DropCostState, parcels:Parcel[]) {
    state.dropCostParcels = parcels
  },
  reset (state:DropCostState) {
    state.dropCostParcels = []
  }
}
const actions = <ActionTree<DropCostState, any>>{
  loadDropCostReport (store: ActionContext<DropCostState, any>, parcelFilter:ParcelFilter): Promise<any> {
    return webApi.drop_cost.get_Drop_Cost_Report(parcelFilter).then((result) => {
      store.commit('setDropCostParcels', result.data)
      return Promise.resolve('success')
    }).catch((response) => {
      window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
      return Promise.reject(response)
    })
  },
  reset (store: ActionContext<DropCostState, any>):void {
    store.commit('reset')
  }
}
const getters = <GetterTree<DropCostState, any>> {

}
export default ({
  namespaced: true,
  state: new DropCostState(),
  mutations,
  actions,
  getters
})
